// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Sitemap_Wrapper__3SKQx","Item":"Sitemap_Item__151PX"};